// extracted by mini-css-extract-plugin
module.exports = {"AgentsTable":"ErpAgentsTable_AgentsTable__2aVU3","rowName":"ErpAgentsTable_rowName__32dJ9","tooltip":"ErpAgentsTable_tooltip__qZYZH"};